import { makeStyles, Theme } from '@material-ui/core'

import { iconStaticClassName } from '../Icon'
import { TypographyProps } from './TypographyProps'

const weights = {
  regular: 400,
  medium: 500,
  'semi-bold': 600,
  bold: 700,
}

const getCustomColor = (theme: Theme, color: string) => {
  const isCommonColor = color && ['white', 'black'].includes(color)
  const isGreyColor = color && color.match(/^grey\.\d{3}/)
  const isSemanticColor = color && color.match(/(primary|secondary|info|success|error|warning).?(light|dark)?/)
  const isTextColor = color && ['textPrimary', 'textSecondary'].includes(color)
  switch (true) {
    case isCommonColor:
      // @ts-expect-error - todo.
      return theme.palette.common[color]
    case Boolean(isGreyColor):
      const scale = color.split('.')[1]
      // @ts-expect-error - todo.
      return theme.palette.grey[scale] || theme.palette.grey[900]
    case Boolean(isSemanticColor):
      const [paletteKey, variant = 'main'] = color.split('.')
      // @ts-expect-error - todo.
      return theme.palette[paletteKey][variant]
    case isTextColor:
      // @ts-expect-error - todo.
      return theme.palette.text[color.slice(4).toLowerCase()]
    default:
      return undefined
  }
}

type StyleProps = Pick<TypographyProps, 'color' | 'weight'> & {
  variant: NonNullable<TypographyProps['variant']>
}

export const useTypographyStyles = makeStyles<Theme, StyleProps>((theme) => ({
  root: {
    [`& .${iconStaticClassName}`]: {
      position: 'relative',
      top: '0.125em',
      padding: '0 0.125em',
      boxSizing: 'content-box',
    },
    fontFamily: theme.typography.fontFamily,
    fontWeight: ({ variant, weight }) => (weight ? weights[weight] : theme.typography[variant].fontWeight),
    fontSize: ({ variant }) => theme.typography[variant].fontSize,
    lineHeight: ({ variant }) => theme.typography[variant].lineHeight,
    textTransform: ({ variant }) => theme.typography[variant].textTransform,
    color: ({ color, variant }) => (color && getCustomColor(theme, color)) || theme.typography[variant].color,
  },
  caption: {
    display: 'inline',
  },
  overline: {
    display: 'inline',
  },
}))
